export enum ActionType {
  SETUP = 'setup',
  START = 'start',
  MOVE = 'move',
  STOP = 'stop',
  RESET = 'reset',
  UNDO = 'undo',
}
export enum AnnotationColors {
  BLACK = 0x000000,
  WHITE = 0xffffff,
  ORANGE = 0xf5bc22,
  BLUE = 0x007bff,
  RED = 0xe05f5e,
}
export const LINE_WIDTH_TO_VIEWPORT_RATIO = 1 / 750
export const DEFAULT_LINE_WIDTH = 3 // * ratio (above) * viewport minimum dimension
export const DEFAULT_COLOR = AnnotationColors.RED
export const DRAW_EVENTS = ['start', 'move', 'stop']

export function colorToString(color: number): string {
  return `#${color.toString(16).padStart(6, '0')}`
}
